module.exports = __webpack_public_path__ + "static/media/placeObject.38582fc2.gif";